export default __webpack_public_path__ + "static/media/datepicker_range.2cc0d320.png";